import { AnalyzeRasComponent } from '../components/ras/analyze-ras/analyze-ras.component';
import { DescriptionRasComponent } from '../components/ras/description-ras/description-ras.component';
import { OperationsAndInstrumentsRelatedToRASComponent } from '../components/ras/operations-and-instruments-related-to-ras/operations-and-instruments-related-to-ras.component';
import { PeopleRelatedToTheRASComponent } from '../components/ras/people-related-to-the-ras/people-related-to-the-ras.component';
import { PersonInvolvedRasComponent } from '../components/ras/person-involved-ras/person-involved-ras.component';
import { SucursalRasComponent } from '../components/ras/sucursal-ras/sucursal-ras.component';

export const COMPONENTS = [
  {
    name: 'Analizar RAS',
    value: 'analyzeRas',
    component: AnalyzeRasComponent,
    caso: 'Legitimación de Capitales',
  },
  {
    name: 'Persona Implicada en la actividad sospechosa.',
    value: 'personInvolvedRas',
    component: PersonInvolvedRasComponent,
    caso: 'Legitimación de Capitales',
  },
  {
    name: 'Descripción del RAS.',
    value: 'descriptionRas',
    component: DescriptionRasComponent,
    caso: 'Legitimación de Capitales',
  },
  {
    name: 'Sucursal',
    value: 'sucursalRas',
    component: SucursalRasComponent,
    caso: 'Legitimación de Capitales',
  },
  {
    name: 'Operaciones e instrumentos relacionados con RAS',
    value: 'operationsAndInstrumentsRelatedToRAS',
    component: OperationsAndInstrumentsRelatedToRASComponent,
    caso: 'Legitimación de Capitales',
  },
  {
    name: 'Personas relacionadas con el RAS',
    value: 'peopleRelatedToTheRAS',
    component: PeopleRelatedToTheRASComponent,
    caso: 'Legitimación de Capitales',
  },
];
